// types
import { ConfigProps, MenuOrientation, ThemeDirection, ThemeMode } from 'types/config';

export const DASHBOARD_PATH = '/';
export const HORIZONTAL_MAX_ITEM = 7;

const THEME = import.meta.env.VITE_APP_USE_THEME;

type ThemeKey = 'fairplay' | 'xoplay' | 'luckyplay' | 'arionplay' | 'peryplay';

const themeMap: Record<ThemeKey, string> = {
  fairplay: 'theme7',
  xoplay: 'theme3',
  luckyplay: 'theme5',
  peryplay:  'theme2',
  arionplay: 'default',
};

const presetColor:any = themeMap[THEME as ThemeKey] ?? 'default';

const config: ConfigProps = {
    menuOrientation: MenuOrientation.VERTICAL,
    miniDrawer: false,
    fontFamily:`'Manrope', sans-serif`,
    borderRadius: 0,
    outlinedFilled: true,
    mode: ThemeMode.DARK,
    presetColor,
    i18n: 'en',
    themeDirection: ThemeDirection.LTR,
    container: false
};

export default config;
